import { render, staticRenderFns } from "./iot-connect-feature.vue?vue&type=template&id=2c031113&scoped=true"
import script from "./iot-connect-feature.vue?vue&type=script&lang=ts"
export * from "./iot-connect-feature.vue?vue&type=script&lang=ts"
import style0 from "./iot-connect-feature.vue?vue&type=style&index=0&id=2c031113&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c031113",
  null
  
)

export default component.exports